module.exports = __webpack_public_path__ + "static/media/C1-1600x1100.15d2004d.jpg";